module.exports = __webpack_public_path__ + "static/img/brees-2007-top-image-thumb.a0929de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-top-image-thumb.jpg
// module id = KQgN
// module chunks = 1